import React from "react";
import { useFormikContext } from "formik";
import { Grid, TextField, Typography, Box, Paper } from "@mui/material";
import Select from "react-select";

const TestimonyStep = ({ metadata }) => {
    const { values, setFieldValue, touched, errors } = useFormikContext();

    // Opciones del multiselect
    const testimonyTypes = [
        { value: "economia", label: "Economía" },
        { value: "sentimental", label: "Sentimental" },
        { value: "sanidad", label: "Sanidad" },
        { value: "espiritual", label: "Espiritual" },
    ];

    return (
        <Grid container spacing={4}>
            {/* Título y descripción */}
            <Grid item xs={12}>
                <Typography
                    variant="h4"
                    align="center"
                    gutterBottom
                    style={{ fontWeight: "bold", color: "#3f51b5" }}
                >
                    Testimonio
                </Typography>
                <Typography
                    variant="body1"
                    align="center"
                    color="textSecondary"
                    gutterBottom
                >
                    Comparte tu experiencia personal y selecciona los tipos relacionados
                    con tu testimonio.
                </Typography>
            </Grid>

            {/* Campo de texto largo para el testimonio */}
            <Grid item xs={12}>
                <Paper elevation={3} style={{ padding: "16px", borderRadius: "8px" }}>
                    <Typography
                        variant="subtitle1"
                        style={{ marginBottom: "8px", color: "#3f51b5" }}
                    >
                        Comparte tu testimonio
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={6}
                        placeholder="Escribe aquí tu experiencia..."
                        value={values.testimonial || ""}
                        onChange={(e) => setFieldValue("testimonial", e.target.value)}
                        error={touched.testimonial && Boolean(errors.testimonial)}
                        helperText={touched.testimonial && errors.testimonial}
                        variant="outlined"
                    />
                </Paper>
            </Grid>

            {/* MultiSelect para tipos de testimonio */}
            <Grid item xs={12}>
                <Paper elevation={3} style={{ padding: "16px", borderRadius: "8px" }}>
                    <Typography
                        variant="subtitle1"
                        style={{ marginBottom: "8px", color: "#3f51b5" }}
                    >
                        Selecciona los tipos de testimonio
                    </Typography>
                    <Select
                        isMulti
                        options={testimonyTypes}
                        value={testimonyTypes.filter((type) =>
                            values.testimony_types?.includes(type.value)
                        )}
                        onChange={(selectedOptions) =>
                            setFieldValue(
                                "testimony_types",
                                selectedOptions
                                    ? selectedOptions.map((option) => option.value)
                                    : []
                            )
                        }
                        placeholder="Selecciona los tipos de testimonio"
                        styles={{
                            control: (base) => ({
                                ...base,
                                borderColor: "#3f51b5",
                                borderRadius: "8px",
                            }),
                            multiValue: (base) => ({
                                ...base,
                                backgroundColor: "#e3f2fd",
                                color: "#3f51b5",
                            }),
                            multiValueLabel: (base) => ({
                                ...base,
                                color: "#3f51b5",
                            }),
                            multiValueRemove: (base) => ({
                                ...base,
                                color: "#3f51b5",
                                ":hover": {
                                    backgroundColor: "#f50057",
                                    color: "white",
                                },
                            }),
                        }}
                    />
                </Paper>
            </Grid>
        </Grid>
    );
};

export default TestimonyStep;
